module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cashiermanage"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('cashMng.crumbs.L1')))])], 1), _vm._v(" "), (!_vm.role.isCashier) ? _c('div', {
    staticClass: "btn-wrap btn-group"
  }, [_c('div', {
    staticClass: "banner-btn primary-btn",
    class: {
      'banner-btn-ja': _vm.lang === 'ja'
    },
    on: {
      "click": _vm.batchAdd
    }
  }, [_c('i', {
    staticClass: "icon-create"
  }), _vm._v(" "), _c('span', {
    staticClass: "banner-btn__desc"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.crumbs.L4')))])]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn",
    class: {
      'banner-btn-ja': _vm.lang === 'ja'
    },
    on: {
      "click": _vm.addCashier
    }
  }, [_c('i', {
    staticClass: "icon-create"
  }), _vm._v(" "), _c('span', {
    staticClass: "banner-btn__desc"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.crumbs.L3')))])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.status')))]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('common.all'),
      "size": "small"
    },
    on: {
      "change": _vm.stateChange
    },
    model: {
      value: (_vm.stateValue),
      callback: function($$v) {
        _vm.stateValue = $$v
      },
      expression: "stateValue"
    }
  }, _vm._l((_vm.stateLists), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (!_vm.role.haiwai) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("退款权限")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('common.all'),
      "size": "small"
    },
    on: {
      "change": _vm.rightsChange
    },
    model: {
      value: (_vm.rightsValue),
      callback: function($$v) {
        _vm.rightsValue = $$v
      },
      expression: "rightsValue"
    }
  }, _vm._l((_vm.rightsLists), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.cashierData.opusers,
      "row-class-name": "el-table__row_fix",
      "id": "memberredcollect"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "opuid",
      "label": _vm.$t('cashMng.common.number')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "opname",
      "label": _vm.$t('cashMng.mng.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "min-width": "80px",
      "label": _vm.$t('cashMng.mng.mobile')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('cashMng.common.status'),
      "min-width": _vm.role.haiwai ? '140px' : '80px'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "on-text": "",
            "off-text": "",
            "on-color": "#FF8100",
            "off-color": "#d8d8d8",
            "on-value": "1",
            "off-value": "0"
          },
          on: {
            "change": function($event) {
              return _vm.changeStatus(scope.row.opuid, scope.row.status)
            }
          },
          model: {
            value: (scope.row.status),
            callback: function($$v) {
              _vm.$set(scope.row, "status", $$v)
            },
            expression: "scope.row.status"
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "explain"
        }, [_vm._v(_vm._s(scope.row.status == 1 ? _vm.$t('cashMng.mng.status3') : _vm.$t('cashMng.mng.status4')))])]
      }
    }])
  }), _vm._v(" "), (_vm.isRemotePay) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$t('nav.remotePay'),
      "min-width": _vm.role.haiwai ? '140px' : '80px'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "on-text": "",
            "off-text": "",
            "on-color": "#FF8100",
            "off-color": "#d8d8d8",
            "on-value": "1",
            "off-value": "0"
          },
          on: {
            "change": function($event) {
              return _vm.changeRights(scope.row.opuid, scope.row.remotepay)
            }
          },
          model: {
            value: (scope.row.remotepay),
            callback: function($$v) {
              _vm.$set(scope.row, "remotepay", $$v)
            },
            expression: "scope.row.remotepay"
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "explain"
        }, [_vm._v(_vm._s(scope.row.remotepay == 1 ? _vm.$t('cashMng.mng.open') : _vm.$t('cashMng.mng.close')))])]
      }
    }], null, false, 2690035443)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "120",
      "label": _vm.$t('cashMng.mng.op')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-button__fix",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.goDetail(scope.row.opuid)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('cashMng.mng.detail')))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.cashierData.count >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.cashierData.count,
      "current-page": _vm.currentPage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1) : _c('div', {
    staticClass: "table_placeholder"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('cashMng.dialog.title'),
      "visible": _vm.showConfirm,
      "custom-class": "mydialog",
      "top": "20%",
      "before-close": _vm.uploadClose
    },
    on: {
      "update:visible": function($event) {
        _vm.showConfirm = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('cashMng.dialog.d1')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "upload-contain"
  }, [_c('div', [_vm._v(_vm._s(_vm.fileList.length > 0 ? _vm.fileList[0]['name'] : ''))]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.uploadUrl,
      "on-change": _vm.handleChange,
      "on-success": _vm.avatarSuccess,
      "on-error": _vm.avatarFailed,
      "show-file-list": false,
      "auto-upload": false,
      "headers": {
        'lang': _vm.lang
      },
      "accept": "application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.uploadClick
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.dialog.d2')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a', {
    staticClass: "el-button--text",
    attrs: {
      "href": _vm.downUrl,
      "download": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('cashMng.dialog.d4')))]), _vm._v(" "), _c('span', {
    staticClass: "footer-right"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.showConfirm = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancel')))]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.submitUpload
    }
  }, [(_vm.iconLoading) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v(_vm._s(_vm.$t('cashMng.dialog.d3')))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-35067cba"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/cashiermanage/cashiermanage.vue
// module id = 910
// module chunks = 0